module.exports = __webpack_public_path__ + "img/team-member-06.436f4602.jpg";